import { apiClient } from '@/lib/api/client'
import type { HelmUser } from '@/lib/api/types'
import { canQuickEdit } from '@/lib/quick-edit'
import { getHelmSessionUser } from '@/src/lib/auth'
import { useAsyncData } from '@/src/hooks/useAsyncData'

/**
 * Who is who on a list: staff names for the owner column, fetched once rather
 * than once per row, who is signed in, and whether they may quick edit.
 */
export function useHelmPeople() {
  return useAsyncData(async () => {
    const [users, me, profile] = await Promise.all([
      apiClient.listHelmUsers().catch(() => ({ users: [] as HelmUser[] })),
      getHelmSessionUser().catch(() => null),
      apiClient.getProfile().catch(() => null),
    ])
    return {
      users: new Map(users.users.map((user) => [user.id, user])),
      meId: me?.id ?? null,
      canEdit: canQuickEdit(profile),
    }
  }, [])
}

export function personName(user: HelmUser | undefined) {
  if (!user) return 'Someone'
  return user.display_name || user.name || user.email.split('@')[0]
}
